// extracted by mini-css-extract-plugin
module.exports = {"mainReg":"regstration_mainReg__ePT0p","innerReg":"regstration_innerReg__3W80H","textDiv":"regstration_textDiv__1b3BG","textDivInner":"regstration_textDivInner__3rYWy"};